module.exports = __webpack_public_path__ + "img/light-green.adc4f7c6.jpg";